import PropertyTypes from './property-types-db';
import GenericDB from './generic-db';

export default class CitiesDB extends GenericDB {
  constructor() {
    super('properties');
  }

  async getSubCatagories() {
    console.log('getcats');
    const catagories = await super.readAll();
    console.log(catagories);
    const subCatagories = Promise.all(catagories.map(async (entry: { options: any[]; id: string; name: any }) => {
      const subCatagoriesDB = new PropertyTypes(entry.name);
      const subEntry = await subCatagoriesDB.readAll();
      entry.options = [];
      console.log(subEntry);
      entry.options.push(subEntry);
      console.log(entry);
      return entry;
    }));
    console.log('getcat2');
    console.log(subCatagories);

    return subCatagories;
  }
}

// Here you can extend UserProductsDB with custom methods
